<template>
  <section>
    <nav class="level">
      <div class="level-left">
        <b-field>
          <p class="control">
            <span class="button is-static">
              {{ $t('attributes.activation_status') }}
            </span>
          </p>
          <b-select v-model="filterStatus" @input="onFilterStatus">
            <option value="">{{ $t('attributes.all') }}</option>
            <option value="true">{{ $t('attributes.shelve_on') }}</option>
            <option value="false">{{ $t('attributes.shelve_off') }}</option>
          </b-select>
        </b-field>
      </div>
      <div class="level-right">
        <p class="level-item">
          <a class="button is-primary" @click="onAdd">
            <b-icon icon="plus"></b-icon>
            <span>{{ $t('attributes.add') + $t('attributes.banner') }}</span>
          </a>
        </p>
      </div>
    </nav>

    <b-table
      :data="filteredBanners"
      :loading="loading"
      :mobile-cards="false"
      :row-class="setRowClass"
      narrowed
      bordered
    >
      <b-table-column
        field="source"
        :label="$t('attributes.blog_source')"
        width="120"
        centered
        v-slot="props"
      >
        {{ props.row.catalog_banner_id != null ? '類別大圖' : '線別' }}
      </b-table-column>

      <b-table-column
        field="sort"
        :label="$t('attributes.sort')"
        width="75"
        sortable
        numeric
        v-slot="props"
      >
        {{ props.row.sort }}
      </b-table-column>

      <b-table-column
        field="status"
        :label="$t('attributes.activation_status')"
        width="75"
        sortable
        centered
        v-slot="props"
      >
        <b-tag
          :type="props.row.status ? 'is-info' : 'is-danger'"
          size="is-medium"
        >
          {{ activeStatus(props.row.status) }}
        </b-tag>
      </b-table-column>

      <b-table-column
        field="start_date"
        :label="$t('attributes.start_date')"
        width="120"
        sortable
        centered
        v-slot="props"
      >
        {{
          props.row.area_banner_start != null
            ? props.row.area_banner_start.split('T')[0]
            : props.row.area_banner_start
        }}
      </b-table-column>

      <b-table-column
        field="end_date"
        :label="$t('attributes.end_date')"
        width="120"
        sortable
        centered
        v-slot="props"
      >
        {{
          props.row.area_banner_end != null
            ? props.row.area_banner_end.split('T')[0]
            : props.row.area_banner_end
        }}
      </b-table-column>

      <b-table-column
        :label="$t('attributes.picture')"
        width="120"
        centered
        v-slot="props"
      >
        <a
          v-if="props.row.picture"
          :href="
            props.row.catalog_banner_id != null
              ? props.row.picture
              : AreaBannerImage(props.row.picture)
          "
          @click.prevent="
            onClickImage(props.row.picture, props.row.catalog_banner_id)
          "
        >
          <figure class="image">
            <img
              :src="
                props.row.catalog_banner_id != null
                  ? props.row.picture
                  : AreaBannerImage(props.row.picture)
              "
              :alt="$t('attributes.picture')"
              style="width: 120px; margin: auto;"
            />
          </figure>
        </a>
      </b-table-column>

      <b-table-column
        :label="$t('attributes.mobile_picture')"
        width="100"
        centered
        v-slot="props"
      >
        <a
          v-if="props.row.mobile_picture"
          :href="
            props.row.catalog_banner_id != null
              ? props.row.mobile_picture
              : AreaBannerImage(props.row.mobile_picture)
          "
          @click.prevent="
            onClickImage(props.row.mobile_picture, props.row.catalog_banner_id)
          "
        >
          <figure class="image">
            <img
              :src="
                props.row.catalog_banner_id != null
                  ? props.row.mobile_picture
                  : AreaBannerImage(props.row.mobile_picture)
              "
              :alt="$t('attributes.picture')"
              style="width: 64px; margin: auto;"
            />
          </figure>
        </a>
      </b-table-column>

      <b-table-column
        field="name"
        :label="$t('attributes.name')"
        sortable
        v-slot="props"
      >
        <p v-html="props.row.name"></p>
      </b-table-column>

      <b-table-column
        field="has_video"
        :label="$t('attributes.has_video')"
        width="140"
        sortable
        centered
        v-slot="props"
      >
        {{ whetherStatus(props.row.has_video) }}
      </b-table-column>

      <b-table-column
        field="url"
        :label="$t('attributes.url')"
        width="120"
        centered
        v-slot="props"
      >
        <a v-if="props.row.url" :href="props.row.url" target="_blank">
          {{ props.row.has_video ? '影片連結' : '外連' }}
        </a>
      </b-table-column>

      <b-table-column :width="150" label="功能" centered v-slot="props">
        <b-button
          type="is-primary"
          size="is-small"
          outlined
          @click.prevent="onModify(props.row)"
        >
          {{ $t('attributes.modify') }}
        </b-button>
        <b-button
          type="is-danger"
          size="is-small"
          outlined
          style="margin-left: 20px;"
          @click.prevent="onDelete(props.row)"
        >
          {{ $t('attributes.delete') }}
        </b-button>
      </b-table-column>

      <template #empty>
        <section class="section">
          <div v-if="!loading" class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large" />
            </p>
          </div>
        </section>
      </template>
    </b-table>

    <b-modal
      :active.sync="isFormModalActive"
      :can-cancel="['escape', 'x']"
      :width="1200"
      has-modal-card
    >
      <banner-form :banner="selectedBanner" :area="area" @send="onSend" />
    </b-modal>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="selectedImageUrl" alt="" />
      </p>
    </b-modal>
  </section>
</template>

<script>
import { AREA_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import BannerForm from './BannerForm'

export default {
  name: 'BannerList',
  components: { BannerForm },

  props: {
    area: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      sending: false,

      code: this.area.code,
      filterStatus: '',
      banners: [],
      filteredBanners: [],

      isFormModalActive: false,
      selectedBanner: null,

      isImageModalActive: false,
      selectedImageUrl: null
    }
  },
  watch: {
    area(newArea) {
      this.code = newArea.code
      this.isFormModalActive = false
      this.selectedBanner = null
      this.loadBannersAsync(newArea.code)
    }
  },
  mounted() {
    this.loadBannersAsync(this.area.code)
  },
  methods: {
    async loadBannersAsync(code) {
      try {
        this.loading = true
        const api = `${AREA_API}/${code}/banners`
        const res = await this.axios.get(api)
        this.banners = res.data.data
      } catch (e) {
        this.banners = []

        notifyService.fetch_error('banner', e)
      } finally {
        this.onFilterStatus()
        this.loading = false
      }
    },
    onFilterStatus() {
      if (!this.filterStatus) {
        this.filteredBanners = this.banners
        return
      }

      this.filteredBanners = this.banners.filter(
        b => b.status === (this.filterStatus === 'true')
      )
    },
    setRowClass(row) {
      if (!row.status) {
        return 'is-off'
      } else {
        return this.checkDateValid(row.area_banner_start, row.area_banner_end)
          ? 'is-valid'
          : 'is-invalid'
      }
    },
    checkDateValid(start_date, end_date) {
      const nowDate = new Date()
      return (
        Date.parse(start_date) <= nowDate && Date.parse(end_date) >= nowDate
      )
    },
    onAdd() {
      this.selectedBanner = {
        id: null,
        name: '',
        sort: 1,
        status: true,
        action: 'A',
        picture: null,
        catalog_banner_id: null
      }
      this.isFormModalActive = true
    },
    onModify(item) {
      this.selectedBanner = item
      this.isFormModalActive = true
    },
    onDelete(item) {
      this.$buefy.dialog.confirm({
        message: this.$t('attributes.confirm_delete'),
        onConfirm: () => {
          this.deleteItem(item)
        }
      })
    },
    onSend(item) {
      if (item.id == null) {
        this.create(item)
      } else {
        this.update(item)
      }
    },
    async create(item) {
      const api = `${AREA_API}/${this.code}/banners`

      try {
        this.sending = true
        const res = await this.axios.post(api, item)
        const _item = res.data.data

        const banners = [...this.banners, _item]
        this.banners = banners.sort((t1, t2) => t1.sort - t2.sort)
        this.onFilterStatus()

        this.isFormModalActive = false
        notifyService.success(this.$t('attributes.add_succeed'))
      } catch (e) {
        notifyService.create_error(e)
      } finally {
        this.sending = false
      }
    },
    async update(item) {
      const api = `${AREA_API}/${this.code}/banners/${item.id}`

      try {
        this.sending = true
        const res = await this.axios.put(api, item)
        const _item = res.data.data

        const idx = this.banners.findIndex(s => s.id === _item.id)
        const banners = [...this.banners]
        banners[idx] = _item
        this.banners = banners.sort((t1, t2) => t1.sort - t2.sort)
        this.onFilterStatus()

        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    },
    async deleteItem(item) {
      try {
        const api = `${AREA_API}/${this.code}/banners/${item.id}`

        this.sending = true
        await this.axios.delete(api)
        notifyService.success(this.$t('attributes.delete_succeed'))

        await this.loadBannersAsync(this.code)
      } catch (e) {
        notifyService.delete_error(e)
      } finally {
        this.sending = false
      }
    },
    onClickImage(url, catalog_banner_id) {
      this.isImageModalActive = true
      this.selectedImageUrl =
        catalog_banner_id != null ? url : this.AreaBannerImage(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.b-table {
  td {
    vertical-align: middle;
  }
}
</style>
